import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { Univers } from '../../Pages/Public/Univers.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteUnivers = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const show = 0;
    const [parks, setParks] = useState([]);
    const [att, setAtt] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataAtt = await fetch(`${backend}/nav/attractions`, GetHeaders(guest));
            const att = await dataAtt.json();
            setAtt(att);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                {navParks.map((el) => {
                    return (
                        el.univers.map((u, i) => {
                            return (<Route path={u.uroute} element={<Univers id={u.uid} navParks={navParks} att={att} />} key={i} />)
                        })
                    )
                })}
                <Route path="*" element={<NotFound navParks={navParks} show={show} />} />
            </Routes>
        </BrowserRouter>
    )
}